export default function DeleteIcon({
  color = "currentColor",
}: {
  color?: string;
}) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 8.00033L15.2367 15.756C15.1032 17.4926 13.655 18.8337 11.9132 18.8337H8.08677C6.34498 18.8337 4.89684 17.4926 4.76326 15.756L4.16667 8.00033M17.5 6.33366C15.3351 5.27864 12.7614 4.66699 10 4.66699C7.23862 4.66699 4.66493 5.27864 2.5 6.33366M8.33333 4.66699V3.83366C8.33333 2.91318 9.07953 2.16699 10 2.16699C10.9205 2.16699 11.6667 2.91318 11.6667 3.83366V4.66699M8.33333 9.66699V14.667M11.6667 9.66699V14.667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
